export type MeasurementEnvironmentErrorCode =
  | 'FONT_NOT_READY'
  | 'FONT_NOT_FOUND'
  | 'FONT_FALLBACK_DETECTED'
  | 'UNSUPPORTED_DPR'
  | 'ZOOM_MISMATCH';

export interface MeasurementEnvironmentDetails {
  actualDevicePixelRatio?: number;
  expectedDevicePixelRatio?: number;
  actualZoom?: number;
  expectedZoom?: number;
  fontsLoaded?: string[];
  missingFonts?: string[];
  message?: string;
}

export class MeasurementEnvironmentError extends Error {
  public readonly code: MeasurementEnvironmentErrorCode;
  public readonly details?: MeasurementEnvironmentDetails;

  constructor(code: MeasurementEnvironmentErrorCode, message: string, details?: MeasurementEnvironmentDetails) {
    super(message);
    this.name = 'MeasurementEnvironmentError';
    this.code = code;
    this.details = details;
  }
}

/**
 * Example usage (inside MeasurementHost):
 *
 * const EXPECTED_DPR = 1;
 * if (window.devicePixelRatio !== EXPECTED_DPR) {
 *   throw new MeasurementEnvironmentError(
 *     'UNSUPPORTED_DPR',
 *     'Device pixel ratio is not supported for deterministic measurement.',
 *     { actualDevicePixelRatio: window.devicePixelRatio, expectedDevicePixelRatio: EXPECTED_DPR }
 *   );
 * }
 *
 * const requiredFonts = ['Inter'];
 * const loaded = Array.from((document as any).fonts || []);
 * const missing = requiredFonts.filter(f => !loaded.find((ff: any) => String(ff.family || '').includes(f)));
 * if (missing.length) {
 *   throw new MeasurementEnvironmentError(
 *     'FONT_NOT_FOUND',
 *     'One or more required fonts are not available.',
 *     { fontsLoaded: loaded.map((ff: any) => String(ff.family || '')), missingFonts: missing }
 *   );
 * }
 */


